import { render, staticRenderFns } from "./about-history.vue?vue&type=template&id=aa09fdb0&scoped=true&"
import script from "./about-history.vue?vue&type=script&lang=js&"
export * from "./about-history.vue?vue&type=script&lang=js&"
import style0 from "./about-history.vue?vue&type=style&index=0&id=aa09fdb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa09fdb0",
  null
  
)

export default component.exports